import useMobileDevice from "../../../hooks/useMobileDevice";
import LeftImages from "./LeftImages";
import SmallImages from "./SmallImages";

function ProductGallery({ images }) {
  const { isMobile } = useMobileDevice();
  return (
    <>
      {isMobile ? (
        <SmallImages images={images} />
      ) : (
        <LeftImages images={images} />
      )}
    </>
  );
}

export default ProductGallery;
